export enum Modules {
  Agency = 'agency',
  Business = 'business',
  BusinessSettings = 'businessSettings',
  LocationDashboard = 'locationDashboard',
  PipelineSettings = 'pipelineSettings',
  AgentReporting = 'agentReporting',
  Reputation = 'reputation',
  AdReporting = 'adReporting',
  Blogs = 'blogs',
  AppointmentReporting = 'apptReporting',
  Eliza = 'eliza',
  Launchpad = 'launchpad',
  ContactDetail = 'contactDetail',
  Task = 'task',
  ChatWidgetBuilder = 'chatWidgetBuilder',
  Yext = 'yext',
  SmartList = 'smartList',
  CustomField = 'customField',
  RestoreContacts = 'restoreContacts',
  BulkActions = 'bulkActions',
  Payments = 'payments',
}
